/**
 * 리소스 해제 함수들을 모았다가 한꺼번에 정리하는 용도다.
 * add 함수로 해제 함수들을 모으고 dispose함수로 한꺼번에 정리한다.
 */
export class Disposable {
    constructor() {
        this._disposers = [];
    }
    add(disposer) {
        this._disposers.push(disposer);
    }
    dispose() {
        for (const disposer of this._disposers) {
            disposer.dispose();
        }
        this._disposers = [];
    }
}
//# sourceMappingURL=disposable.js.map